import React from 'react'
import {MdClose} from 'react-icons/md'
import PropTypes from 'prop-types'

function CloseIcon(props) {
  return props.show ? <MdClose {...props} /> : null
}

CloseIcon.propTypes = {
  show: PropTypes.bool
}

export default CloseIcon
